import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const options: string[] = ["1", "2", "3"];

interface Props {
	name: string;
}

export const EventPrioritySelect: FC<Props> = ({ name }) => {
	const { t } = useTranslation();

	return <SingleSelectField name={name} label={t("Event priority")} options={options} getLabel={String} />;
};
